import React,{Fragment, Component} from 'react';
import {Link} from 'react-router-dom';
import largeimg from './../../images/blog/large/pic1.jpg';
import largeimg1 from './../../images/blog/large/pic4.jpg';
import largeimg2 from './../../images/blog/large/pic5.jpg';
import largeimg3 from './../../images/blog/large/pic6.jpg';
import largeimg4 from './../../images/blog/large/pic7.jpg';

function Paragraph(){
	return(
		<>
			<p>
				Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting.
			</p>
		</>
	)
}
class ClassDetailContent extends Component{
	render(){
		return(
			<Fragment>
				<div className="classes-details">
					<div className="class-media">
						<img src={largeimg1} alt="" />
					</div>
					<div className="class-info">
						<div className="dlab-post-title ">
							<h2 className="post-title m-t0">Educational Trips</h2>
						</div>

						<div className="dlab-post-text">
							<p>
								Educational trips are a regular part of the school’s curriculum, we frequently arrange trips to NGOs, museums and more to
								help develop a learning attitude from an early age, today’s children are learning things at an ever faster rate and we leave
								no stone unturned in making sure that they get all means of knowledge gartering. All arrangements are taken care by the
								school including transportation, food and safety.
							</p>

							<h4>Excursion</h4>
							<p>
								We organize outings at nearby parks, religious places, Dominos et cetera, this proves as a nice little change for children and
								therefore brings that extra excitement in their lives, it also allows them to interact closely with nature and learn more about
								things around them. The School takes care of all transportation, refreshments and other essential arrangements
							</p>
							<h4>Competition</h4>
							<p>
								The School regularly organizes various competitions like fancy dress competitions, writing competitions, drawing competitions,
								rhyme and recitation competitions, dance competitions, coloring competitions and many more. Such events imbibe positive
								competitive spirit in children and help them develop presentation skills and self-confidence.
							</p>
							<h4>Social activities</h4>
							<p>
								Compassion towards society and our whole planet is something which is not present in abundance today. At Kimaya, we believe
								changing this equation originates from our home and depends on the zeal of our next generation. With that in mind, we happily
								arrange Tree planting activities, helping and donating to the needy, visits to old age homes, we also celebrate Environment day
								and Earth day with great fanfare and especially use these days to import more knowledge and awareness to the students.
							</p>

						</div>

					</div>
				</div>

				<div className="classes-details">
					<div className="class-media">
						<img src={largeimg2} alt="" />
					</div>
					<div className="class-info">
						<div className="dlab-post-title ">
							<h2 className="post-title m-t0">Teacher-student ratio</h2>
						</div>

						<div className="dlab-post-text">
							<p>
								we believe teachers to be the most important link in the learning chain especially for children in this age group. Our teachers are trained to be the torch bearers of our mission. Teachers at Kimaya impart knowledge with compassion and care, they facilitate a child’s development by switching roles between keen observers and sometimes even challengers this ensures that children learn and only move in one direction which is forward.
							</p>
							<blockquote>
								All our teacher are required to go through an extensive training
								program during which they gain a deep understanding of our teaching practices, teaching curriculum, lesson plans and other
								similar programs. Kimaya has adopted a play way method which is part of an activity-based learning, this invokes interest of
								children at every step and they are able to learn without any added stress of performance. Our teachers follow a child-oriented
								technique to make sure every child in the classroom is able to move a head at the same pace and no child is left behind.
							</blockquote>

							<h4>Teaching Methods</h4>
							<p>
								The innovative books, flash cards, activity sheets and other learning material & concepts have been meticulously written and designed
								by highly qualified experts, our books are colourful, attractive and engaging, which attracts the curious minds of little ones.
							</p>
						</div>

					</div>
				</div>

				<div className="classes-details">
					<div className="class-media">
						<img src={largeimg3} alt="" />
					</div>
					<div className="class-info">
						
							<h4>Activity area</h4>
							<p>
								Kimaya boasts of a fun filled activity room that is both inviting and thought provoking. We genuinely believe in ‘activity based’
								learning technique and therefore take pride in our praise worthy activity hall. Here children have the option of engrossing
								themselves into anyone of the available like Doll house, Ball room, open zoo (with stuffed animals),Toy section, Puzzle
								section, Board game etc. which further vivifies learning for them and allows them to develop motor skills and quickens
								their reflexes leading to an overall healthy lifestyle.
							</p>

							<h4>Smart board with Audio / visual aids</h4>
							<p>
								We believe that in today’s world technology is major enabler and it’s no different in a child’s world, we’ve made sure that we
								use technology to accelerate learning and make it easier for kids to pick things up and remember them longer. Our interactive
								smart board system provides participants with a fun and engaging way to learn things.
							</p>

							<h4>Stage exposure</h4>
							<p>
								We strive to train children to tackle their fears early in life and overcome them so that they can become all that they can be in life and
								are not bound by fears or inhibitions. This practice also goes a long way in developing confidence early in life so they achieve more in
								future.
							</p>

							<h4>Outdoor Play Area</h4>
							<p>
								As a Play school, we obviously take the ‘play’ part of it quite seriously, our play area contains Doll house, safe swings,
								small and safe slides, splashpool, trampolines, multiple toy cars and much more. We believe physical activity through playing is
								essential throughout the lifetime but is imperative throughout the early years of the child as it goes a long way in not just developing a
								healthy brain and body but also sharpening their social and language skills.
							</p>

							<h4>Tasty meals Galore</h4>
							<p>
								Providing a hygienic and tasty meal everyday to the children is part of Kimaya family, we offer delicious food to our children who have
								always complimented our cooking by finishing their meals every time. We also teach table manners, personal hygiene sharing and the
								importance of not wasting food. Our menu has a different dish for every day of the week with special add-ons during festivals and
								celebrations.
							</p>

							<h4>Celebrations Enjoyable Activities</h4>
							<p>
								One of the many benefits of being from such a diverse country is that one gets to celebrate all kinds of festivals in a year. At Kimaya,
								we celebrate every occasion with our children and even with our extended family, that is , parents and grandparents. We welcome all
								cultures and all religions and happily celebrates all important festivals. We try to make sure that all children learn about every
								important festival of all cultures, this encourages inclusion and tolerance from an early age. We also celebrate with equal fanfare all
								Birthdays and important events, this ensures an ambience of happiness and activity in the school that keeps everybody active and
								pumped.
							</p>

					</div>
				</div>
				<div className="classes-details">
					<div className="class-media">
						<img src={largeimg4} alt="" />
					</div>
					<div className="class-info">
						<div className="dlab-post-title ">
							<h2 className="post-title m-t0">Parent Partnership</h2>
						</div>

						<div className="dlab-post-text">
							<p>
								We at Kimaya realize that before children come to our school they’ve already started learning from their parents,
								So, it becomes essential to open a bridge between our staff and parents of the ward so that a free and open
								communication channel can function between them. This helps us to customize our attention and techniques
								towards each child so that he/she can benefit from the information flow. We also understand that parents will
								always be the first teachers that a child comes to know so keeping parents and family members in the loop is
								imperative for a constant growth of the child.
							</p>
							<blockquote>
								Here at Kimaya, we encourage communication between teachers and parents through all forms, even the director of our school
								is always approachable and available in the school, her involvement in all facets of the school gives us an advantage over
								traditional hierarchial models by enhancing a sense of extra care among all staff and ensuring the safety of every child.
							</blockquote>

							<h4>Formal School Admission</h4>
							<p>
								To ease the difficult and demanding task of securing admission for your ward in a formal school, we provide consulting, training
								and mock interviews for the parents and their children to maximize the chances of admissions in desired schools. Our school has
								already established a good reputation among all nearby formal schools and this further helps in all aviating parents’ stress.
							</p>

						</div>

					</div>
				</div>

			</Fragment>
		)
	}
}
export default ClassDetailContent;